import { AxiosProgressEvent } from 'axios'

export const transformProgressEventToNumber = (
  progressEvent: AxiosProgressEvent,
) => Math.round((progressEvent.loaded * 100) / Number(progressEvent.total))
